import { createAction, handleActions } from 'redux-actions';

import Agent from '../api/Agent';
import { handleError } from './user';

export const setLoyaltyLevel = createAction('SET_LOYALTY_LEVEL');
export const setLoyaltyRewards = createAction('SET_LOYALTY_REWARDS');
export const setBargraphLoyaltyEvents = createAction('SET_BARGRAPH_LOYALTY_EVENTS');
export const setLoyaltyEventsFetching = createAction('SET_LOYALTY_EVENTS_FETCHING');

const initialState = {
	bargraphEvents: [],
	eventsFetching: false,
	level: [],
	rewards: {}
};

export default handleActions(
	{
		SET_BARGRAPH_LOYALTY_EVENTS: (state, action) => ({ ...state, bargraphEvents: action.payload }),
		SET_LOYALTY_EVENTS_FETCHING: (state, action) => ({ ...state, eventsFetching: action.payload }),
		SET_LOYALTY_LEVEL: (state, action) => ({ ...state, level: action.payload }),
		SET_LOYALTY_REWARDS: (state, action) => ({ ...state, rewards: action.payload })
	},
	initialState
);

export const getLoyaltyLevel = () => {
	return function (dispatch) {
		Agent.getLoyaltyLevel().then((response) => {
			if (response.ok) {
				dispatch(setLoyaltyLevel(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const getLoyaltyEventsByNurseId = (id, fromDate, toDate) => {
	return function (dispatch) {
		dispatch(setLoyaltyEventsFetching(true));
		Agent.getLoyaltyEventsByNurseId(id, fromDate, toDate).then((response) => {
			dispatch(setLoyaltyEventsFetching(false));
			if (response.ok) {
				dispatch(setLoyaltyEvents(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const getBargraphLoyaltyEventsByNurseId = (id) => {
	return function (dispatch) {
		dispatch(setLoyaltyEventsFetching(true));
		Agent.getLoyaltyEventsByNurseId(id).then((response) => {
			dispatch(setLoyaltyEventsFetching(false));
			if (response.ok) {
				dispatch(setBargraphLoyaltyEvents(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const getLoyaltyRewards = () => {
	return function (dispatch) {
		Agent.getLoyaltyRewards().then((response) => {
			if (response.ok) {
				dispatch(setLoyaltyRewards(response.data));

				return;
			}

			dispatch(handleError(response));
		});
	};
};
